import React, { useState } from 'react';
import { toISOFormat } from '../../utils/standaloneUtils';
import Button from "../../Components/forms/Button";
import Input from "../../Components/forms/Input";
import TipInput from "../../Components/forms/TipInput";
import Loading from "../../Components/Loading";
import ModalWebPushConfirm from "../../Components/ModalWebPushConfirm";
import DefaultButton from "../../Components/forms/DefaultButton"
import LogoPush from "../../assets/web_not.svg";
import styles from "./WebPush.module.css";
import { db } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import dayjs from 'dayjs';
import "dayjs/locale/en-gb"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

const WebPush = () => {
  const [data, setData] = React.useState({ // objeto para fazer a contagem de tokens
    tokens: []
  });
  const [dataObj, setDataObj] = useState({
    title: "",
    body: "",
    url: "https://www.santander.com.br/",
    img: "https://www.santander.com.br/sites/WPC_Banco/assets/images/oferta-contextual/logo_santander_100x100_v0_chama_verm.jpg",
    imgDestaque: "https://www.santander.com.br/sites/WPC_Banco/assets/images/hospedagem-imagens/logo-santander-webpush.jpg",
    dateSchedule: new Date(),
    audience: "Clientes Cadastrados",
    urlFluxo: "",
    tokensQtd: 0,
    hasImageToShow: null,
    hasCutoffDate: null,
    cutofDate: null,
    recurrence: null,
    recurrenceCheckboxWeekly: null,
    recurrenceSendPost: null,
    recurrenceDayMonth: null,
    recurrenceTime: null
  });
  const [recurrenceDateTime, setRecurrenceDateTime] = React.useState(dayjs(new Date()));
  const [dateTime, setDateTime] = React.useState(dayjs(new Date()));

  const imgExemple = require("../../assets/logo.png");
  const [tokens, setTokens] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [totalClient, setTotalClient] = React.useState(-1);
  const [statusModal, setStatusModal] = React.useState(false);
  const [dateState, setDateState] = React.useState(toISOFormat(new Date()));

  const [triggerError, setTriggerError] = useState('A URL gatilho não pode estar em branco')
  const [cutOfDateError, setcutOfDateError] = useState('A Data de corte não pode estar em branco')
  const [checkboxError, setCheckboxError] = useState('O Dia da semana não pode estar em branco')
  const [recurrenceTypeError, setRecurenceTypeError] = useState('O campo tipo de ocorrência não pode estar em branco')
  const [recurrenceSendPostError, setRecurrenceSendPostError] = useState('O envio após não pode estar em branco')
  const [dayOfMonthError, setDayOfMonthError] = useState('O dia do mês não pode estar em branco')
  const [recurrenceTimeError, setRecurrenceTimeError] = useState('O horário não pode estar em branco')
  const [dateStateError, setDateStateError] = useState(false)
  const [tituloError, setTituloError] = useState('O título não pode estar em branco')
  const [textoError, setTextoError] = useState('O texto da notificação não pode estar em branco')
  const [urlError, setUrlError] = useState(false)
  const [imageError, setImageError] = useState('')
  const [imgDestaqueError, setImgDestaqueError] = useState('')

  const [hasImage, setHasImage] = React.useState(false);
  const [hasChecked, setHasChecked] = React.useState(false);
  const [hasDaysPeriod, setHasDays] = React.useState(false);
  const [hasRecurrence, setHasRecurrence] = React.useState(false)
  const [hasRecurenceType, setRecurenceType] = React.useState('')


  React.useEffect(() => {
    async function getToken() {
      try {
        setLoading(true);
        const queryToken = collection(db, "webpush-tokens-count");
        const docs = await getDocs(queryToken);
        docs.forEach((doc) => {
          setTokens((tokens) => [...tokens, doc.data()]);
        });
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    if (tokens.length === 0) {
      getToken();
    }
  }, []);





  React.useEffect(() => {
    setData({ ...data, tokens: tokens });
  }, [tokens, loading]);

  React.useEffect(() => {
    var sumTokens = 0;
    data.tokens.forEach((doc) => {
      sumTokens = sumTokens + Number(doc.total)
    });
    setTotalClient(sumTokens);
  }, [data.tokens, data.audience]);

  function handleSelectAudience({ target }) {
    if (!target.value) {
      setDataObj({
        ...dataObj,
        tokensQtd: 0,
        audience: "",
        urlFluxo: "",
      });
      setTotalClient(-1);
      setTriggerError('A URL gatilho não pode estar em branco')
    } else if (target.value === "todos") {
      let totalRegisteredClients = tokens.reduce((accumulator, object) => accumulator + object.total, 0);
      setData({
        ...data,
        tokens: tokens,
        audience: target[target.selectedIndex].text,
        urlFluxo: target[target.selectedIndex].value,
      });
      setDataObj({
        ...dataObj,
        tokensQtd: totalRegisteredClients,
        audience: target[target.selectedIndex].text,
        urlFluxo: target[target.selectedIndex].value
      });
      setTotalClient(totalRegisteredClients);
      setTriggerError(false)
      //TODO: Validar Clientes impactados para o cenário abaixo.//
    } else {
      var countfiltered = tokens.filter(function (token) {
        if (token.url != null) {
          return token.url.includes(target.value);
        }
      }).length;
      setData({
        ...data,
        tokens: tokens.filter((token) => {
          if (token.url != null) {
            return token.url.includes(target.value);
          }
        }),
        audience: target[target.selectedIndex].text,
        urlFluxo: target[target.selectedIndex].value,
      });
      setDataObj({
        ...dataObj,
        audience: target[target.selectedIndex].text,
        urlFluxo: target[target.selectedIndex].value,
        tokensQtd: countfiltered
      });
      setTriggerError(false)
    }
  }

  function handleCutOfDate({ target }) {
    if (!target.value) {
      setDataObj({
        ...dataObj,
        cutofDate: "",
      });
      setcutOfDateError('A Data de Corte não pode estar em branco')

    } else if (target.value === "todos") {
      setData({
        ...data,
        cutofDate: target[target.selectedIndex].value,
      });
      setcutOfDateError(false)
    } else {
      setData({
        ...data,
        cutofDate: target[target.selectedIndex].value,
      });
      setDataObj({
        ...dataObj,
        cutofDate: target[target.selectedIndex].value,
      });
      setcutOfDateError(false)
    }
  }

  function handleWeekly({ target }) {
    const value = parseInt(target.value)
    setHasChecked(!target.checked);
    if (target.checked) {
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly:
          dataObj.recurrenceCheckboxWeekly.concat(...[value]),
      })
      setCheckboxError(false)

    } else {
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly:
          dataObj.recurrenceCheckboxWeekly.filter(val => val !== value),
      })

    }
  }

  React.useEffect(() => {
    dataObj.recurrenceCheckboxWeekly?.length ?
      setCheckboxError(false) :
      setCheckboxError('O Dia da semana não pode estar em branco')
  });

  function handleDayOfMonth({ target }) {
    if (!target.value) {
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly: null,
        recurrenceSendPost: null,
        recurrenceDayMonth: "",
      });
      setDayOfMonthError('O dia do mês não pode estar em branco')
    } else {
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly: null,
        recurrenceSendPost: null,
        recurrenceDayMonth: parseInt(target[target.selectedIndex].value),
      });
      setDayOfMonthError(false)
    }
  }

  function handleSendPost(target) {
    if (!target) {
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly: null,
        recurrenceSendPost: "",
        recurrenceDayMonth: null,
        recurrenceTime: null
      });
      setRecurrenceSendPostError('O envio após não pode estar em branco')
    } else {
      setDataObj({
        ...dataObj,
        recurrenceSendPost: `${target.$H}:${target.$m}`,
        recurrenceCheckboxWeekly: null,
        recurrenceDayMonth: null,
        recurrenceTime: null
      });
      setRecurrenceDateTime(target)
      setRecurrenceSendPostError(false)
    }
  }

  function handleTime(target) {
    if (!target) {
      setDataObj({
        ...dataObj,
        recurrenceTime: null,
      });
      setRecurrenceTimeError('O horário não pode estar em branco')
    } else {
      setDataObj({
        ...dataObj,
        recurrenceTime: `${target.$H}:${target.$m}`,
      });
      setRecurrenceDateTime(target)
      setRecurrenceTimeError(false)
    }
  }


  function handleRecurenceType(e) {
    if (!e.target.value) {
      setDataObj({
        ...dataObj,
        recurrence: "",
        recurrenceSendPost: null,
        recurrenceCheckboxWeekly: null,
        recurrenceTime: null,
        recurrenceDayMonth: null
      });
      setHasChecked(false)
      setRecurenceTypeError('O campo de tipo de ocorrência não pode estar em branco')
    } else {
      switch (e.target.value) {
        case 'daily':
          setDataObj({
            ...dataObj,
            recurrence: 'daily',
            recurrenceCheckboxWeekly: null,
            recurrenceTime: null,
            recurrenceDayMonth: null
          });
          setHasChecked(false)
          break

        case 'weekly':
          setHasChecked(!e.target.checked);
          setCheckboxError('O Dia da semana não pode estar em branco')
          setRecurrenceTimeError('O horário não pode estar em branco')
          setDataObj({
            ...dataObj,
            recurrence: 'weekly',
            recurrenceSendPost: null,
            recurrenceTime: null,
            recurrenceDayMonth: null,
            recurrenceCheckboxWeekly: []

          });
          setHasChecked(true)
          break

        case 'monthly':
          setRecurrenceTimeError('O horário não pode estar em branco')
          setDataObj({
            ...dataObj,
            recurrence: 'monthly',
            recurrenceSendPost: null,
            recurrenceTime: "",
            recurrenceCheckboxWeekly: null
          });
          setHasChecked(false)
          break

        default:
          setHasChecked(false)
          break
      }
      setRecurenceType(e.target.value)
      setRecurenceTypeError(false)
    }
  }
  function hasImg(e) {
    setHasImage(e.target.checked);
    if (e.target.checked)
      setDataObj({
        ...dataObj,
        hasImageToShow: e.target.checked,
        imgDestaque: "https://www.santander.com.br/sites/WPC_Banco/assets/images/hospedagem-imagens/logo-santander-webpush.jpg"
      });
    else
      setDataObj({
        ...dataObj,
        hasImageToShow: null,
        imgDestaque: null
      })
  }

  function hasRecurrencePeriod(e) {
    setHasRecurrence(e.target.checked);
    if (e.target.checked)
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly: [],
      })
    else
      setDataObj({
        ...dataObj,
        recurrenceCheckboxWeekly: null,
        recurrenceSendPost: null,
        recurrenceTime: null,
        recurrenceDayMonth: null,
        recurrence: null
      })
  }
  function handleOpenModalConfirm(event) {
    setStatusModal(true);
  }
  function handleCloseModalConfirm() {
    setStatusModal(false);
  }
  function handleDateFormatAndSave(dateObject) {
    setDateTime(dateObject)
    const value = toISOFormat(dateObject.$d)
    let objDate = {
      year: value.slice(0, 4),
      month: Number(value.slice(5, 7)) - 1,
      day: value.slice(8, 10),
      hour: value.slice(11, 13),
      minute: value.slice(14, 16),
    };
    setDateState(value);
    ((new Date(value) < new Date()) || [null, undefined, ''].includes(value)) ?
      setDateStateError('Data inválida') :
      setDateStateError(false)
    setDataObj({
      ...dataObj,
      dateSchedule: new Date(
        objDate.year,
        objDate.month,
        objDate.day,
        objDate.hour,
        objDate.minute,
        0,
        0
      ),
    });
  }

  if (loading) {
    return <Loading>Carregando...</Loading>;
  } else {
    return (
      <main className="container webpush-container">
        <div className="container-page">
          <ModalWebPushConfirm
            isOpen={statusModal}
            onRequestClose={handleCloseModalConfirm}
            setData={setDataObj}
            data={dataObj}
          />

          <div className="title-page">
            <img src={LogoPush} className={styles.iconNav} />
            <h1> Envio Web Push Notifications </h1>
          </div>
          <div className={styles.containerPageWebPush}>
            <form
              className={styles.formsPageWebPush}
              onSubmit={handleOpenModalConfirm}
            >
              <div className={styles.checkboxContainer}>
                <label for="permission">Recorrente:</label>
                <input
                  type="checkbox"
                  id="recorrente"
                  name="recorrente"
                  value="padrao"
                  onChange={(e) => {
                    hasRecurrencePeriod(e)
                  }} />
              </div>
              {hasRecurrence && (<>
                <div className={styles.webSelect}>

                  <div className={styles.selectPageWebPushWrapper}>
                    <select
                      className={`${styles.selectPageWebPush} ${(recurrenceTypeError != '') ? styles.inputError : ''} `}
                      onChange={(e) => {
                        handleRecurenceType(e)
                      }}
                    >
                      <option value="">Tipo de recorrência</option>
                      <option value="daily">Diário</option>
                      <option value="weekly">Semanal</option>
                      <option value="monthly">Mensal</option>
                    </select>

                    <p className={styles.error}>
                      {recurrenceTypeError}
                    </p>
                  </div>
                </div>
                {hasRecurenceType == 'daily' && (<>
                  <div className={styles.selectPageWebPushWrapper}>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}>
                      <MobileTimePicker
                        value={recurrenceDateTime}
                        className={styles.selectTimeWeek}
                        minutesStep={30}
                        onChange={handleSendPost}
                      />
                    </LocalizationProvider>
                    <p className={styles.error}>
                      {recurrenceSendPostError}
                    </p>
                  </div>
                </>)}
                {hasRecurenceType == 'weekly' && (<>
                  <div className={styles.selectWeekly} id="weekly">

                    <div className={`${styles.containerColumnPageWebPush}`}>
                      <div className={styles.containerPageWebPush}>
                        <div className={styles.checkboxContainer}>
                          <label>Domingo</label>
                          <input
                            type="checkbox"
                            name="1"
                            value="1"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                        <div className={styles.checkboxContainer}>
                          <label>Segunda</label>
                          <input
                            type="checkbox"
                            name="2"
                            value="2"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                        <div className={styles.checkboxContainer}>
                          <label>Terça</label>
                          <input
                            type="checkbox"
                            name="3"
                            value="3"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                        <div className={styles.checkboxContainer}>
                          <label>Quarta</label>
                          <input
                            type="checkbox"
                            name="4"
                            value="4"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                        <div className={styles.checkboxContainer}>
                          <label>Quinta</label>
                          <input
                            type="checkbox"
                            name="5"
                            value="5"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                        <div className={styles.checkboxContainer}>
                          <label>Sexta</label>
                          <input
                            type="checkbox"
                            name="6"
                            value="6"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                        <div className={styles.checkboxContainer}>
                          <label>Sábado</label>
                          <input
                            type="checkbox"
                            name="7"
                            value="7"
                            onChange={(e) => {
                              handleWeekly(e)
                            }} />
                        </div>
                      </div>
                      {hasChecked && (<>
                        <p className={styles.errorCheckbox}>
                          {checkboxError}
                        </p>
                      </>)}
                    </div>
                    <div className={`${styles.selectPageWebPushWrapperMini}`}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                          value={recurrenceDateTime}
                          className={styles.selectTimeWeek}
                          minutesStep={30}
                          onChange={handleTime}
                        />
                      </LocalizationProvider>
                      {/* <select
                        className={`${styles.selectTimeWeek} ${(recurrenceTimeError != '') ? styles.inputError : ''} `}
                        onChange={handleTime}
                      >
                        <option value="" selected="">Horário:</option>
                        {availableHours.map((item) => {
                          return (<option value={Object.keys(item)}>{Object.values(item)}</option>)
                        })}
                      </select> */}
                      <p className={styles.error}>
                        {recurrenceTimeError}
                      </p>
                    </div>
                  </div>
                </>)}
                {hasRecurenceType == 'monthly' && (<>
                  <span className={styles.inputTip}>
                    Caso o mês do push tenha MENOS dias que o dia do push, <br />
                    será automaticamente enviado no ÚLTIMO dia do mês!
                  </span>

                  <div className={styles.selectMonthly} >

                    <div className={styles.selectPageWebPushWrapper} id="monthly">
                      <select
                        className={`${styles.selectPageWebPush} ${(dayOfMonthError != '') ? styles.inputError : ''} `}
                        onChange={handleDayOfMonth}
                      >
                        <option value="" selected="">Dia do mês</option>
                        {Array.apply(null, Array(31)).map((x, index) => {
                          return <option value={index + 1}>{index + 1}</option>;
                        })}

                      </select>
                      <p className={styles.error}>
                        {dayOfMonthError}
                      </p>
                    </div>
                    <div className={styles.selectPageWebPushWrapper}>
                      <LocalizationProvider
                        dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                          value={recurrenceDateTime}
                          className={styles.selectTimeWeek}
                          minutesStep={30}
                          onChange={handleTime}
                        />
                      </LocalizationProvider>
                      <p className={styles.error}>
                        {recurrenceTimeError}
                      </p>
                    </div>
                  </div>
                </>)}
              </>)}

              <div className={styles.webSelect}>
                <div className={styles.selectPageWebPushWrapper}>
                  {!hasRecurrence == false && (<TipInput> &nbsp;</TipInput>)}
                  <select
                    className={`${styles.selectPageWebPush} ${(triggerError != '') ? styles.inputError : ''}`}
                    onChange={handleSelectAudience}
                    value={dataObj.urlFluxo}>
                    <option value="">Selecione a URL gatilho</option>
                    <option value="todos">Clientes Cadastrados</option>
                    <option value="form/formtesteofc">Form Teste OFC</option>
                    <option value="renegociacao/pf">Renegociação somente PF</option>
                    <option value="renegociacao/pj">Renegociação somente PJ</option>
                    <option value="renegociacao/loginUTM">Acordo com Limite</option>

                    <option value="credito/home">Crédito Preventivo</option>
                    <option value="/emprestimo/login">Crédito / JUC / Geral</option>

                    <option value="/juc-cp-puro">Crédito / JUC / CP Puro</option>
                    <option value="/juc-csg-puro">Crédito / JUC / CSG Puro</option>
                    <option value="/juc-credito-fgts">Crédito / JUC / FGTS</option>

                    <option value="/upselling/credito">Comprovante Crédito</option>


                    <option value="/banco/capitalizacao">DinDin Capitalização</option>
                    <option value="/investimentos-e-previdencia/cdb-di">CDB DI</option>
                    <option value="/banco/seguro-transacoes">Seguro Transações</option>

                    <option value="/cartao-credito-santander">Cartões</option>
                    <option value="/consorcios/simulacao/comecar/revisao-dados">Consórcio 1(Inicio jornada)</option>
                    <option value="/consorcios/planos/lista/sugestoes">Consórcio 2(Meio jornada)</option>
                    <option value="/consorcios/pagamento/detalhes">Consórcio 3(Fim jornada)</option>
                    <option value="/parcelamento-fatura/simulacao">Parcelamento de fatura</option>
                    <option value="/conta-pj">Conta PJ</option>
                  </select>
                  <p className={styles.error}>
                    {triggerError}
                  </p>
                </div>
                {hasRecurrence == false && (
                  <>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="en-gb"
                    >
                      <MobileDateTimePicker
                        className={styles.dateSelector}
                        value={dateTime}
                        minutesStep={15}
                        onChange={handleDateFormatAndSave}
                        required
                      />
                    </LocalizationProvider>

                  </>
                )}
              </div>
              <p className={styles.titleNotificacao}>Notificação</p>
              <TipInput>Aqui vai o nome da campanha</TipInput>
              <Input
                value={dataObj.title}
                onChange={(e) => {
                  setDataObj({ ...dataObj, title: e.target.value })
                  e.target.value ?
                    setTituloError(false) :
                    setTituloError('O título não pode estar em branco')
                }}
                placeholder={"O título da notificação"}
                type={"text"}
                error={tituloError}
                required
              />
              <TipInput>Uma breve descrição ou um CTA &#40;Recomendado menos de 120 caracteres&#41;</TipInput>
              <Input
                value={dataObj.body}
                onChange={
                  (e) => {
                    setDataObj({ ...dataObj, body: e.target.value })
                    e.target.value ?
                      setTextoError(false) :
                      setTextoError('O texto da notificação não pode estar em branco')
                  }
                }
                placeholder={"Texto da notificação"}
                type={"text"}
                error={textoError}
                required
              />
              <TipInput>Utilizar a URL sempre com "https://"</TipInput>
              <Input
                value={dataObj.url}
                onChange={
                  (e) => {
                    setDataObj({ ...dataObj, url: e.target.value })
                    e.target.value ?
                      setUrlError(false) :
                      setUrlError('A URL da notificação não pode estar em branco')
                  }
                }
                placeholder={"URL da notificação"}
                type={"text"}
                error={urlError}

                required
              />
              <Input
                value={dataObj.img}
                onChange={
                  (e) => {
                    e.preventDefault();
                    setDataObj({ ...dataObj, img: e.target.value })
                    e.target.value ?
                      setImageError(false) :
                      setImageError('A URL da imagem da notificação não pode estar em branco')
                  }
                }
                placeholder={"Icone da notificação"}
                type={"text"}
                error={imageError}

                required
              />
              <TipInput>
                Icone exemplo 100x100(px):<br />"https://www.santander.com.br/sites/WPC_Banco/assets/images/oferta-contextual/logo_santander_100x100_v0_chama_verm.jpg"
              </TipInput><br />

              <div className={styles.checkboxContainer}>
                <label for="permission">Tem imagem de destaque?</label>
                <input
                  type="checkbox"
                  name="destaque"
                  value="destaque"
                  onChange={(e) => {
                    hasImg(e)
                  }} />
              </div>
              {hasImage && (<><Input
                value={dataObj.imgDestaque}
                onChange={(e) => {
                  e.preventDefault();
                  setDataObj({ ...dataObj, imgDestaque: e.target.value });
                  e.target.value ?
                    setImgDestaqueError(false) :
                    setImgDestaqueError('A URL da imagem não pode estar em branco')
                }}
                placeholder={"Imagem destaque da notificação"}
                type={"text"}
                error={imgDestaqueError}

                required
              />
                <TipInput>
                  Imagem de destaque exemplo 400Ax200L(px):<br />"https://www.santander.com.br/sites/WPC_Banco/assets/images/hospedagem-imagens/logo-santander-webpush.jpg"
                </TipInput></>)}<br />

              {/* <div className={styles.checkboxContainer}>
                <label for="permission">Data de corte?</label>
                <input
                  type="checkbox"
                  name="corte"
                  value="corte"
                  onChange={(e) => {
                    hasDays(e)
                  }} />
              </div> */}
              {hasDaysPeriod && (<>
                <div className={styles.selectPageWebPushWrapper}>
                  <select
                    className={`${styles.selectPageWebPush} ${(cutOfDateError != '') ? styles.inputError : ''} `}
                    onChange={handleCutOfDate}
                  >
                    <option value="" selected="">Período</option>
                    {/* #### IMPORTANTE!!!! O Value do Option deve ser o mesmo da url do local storage "webpush_url_entrada" gerada no inico do fluxo  */}
                    <option value="1 dia">1 dia</option>
                    <option value="2 dias">2 dias</option>
                    <option value="3 dias">3 dias</option>
                    <option value="7 dias">7 dias</option>
                    <option value="15 dias">15 dias</option>
                    <option value="30 dias">30 dias</option>
                    <option value="45 dias">45 dias</option>
                    <option value="60 dias">60 dias</option>
                  </select>

                  <p className={styles.error}>
                    {cutOfDateError}
                  </p>

                </div>

              </>)}
            </form>

            <div className={styles.containerPreviewPageWebPush}>
              <div className={styles.containerPreviewPageWebPushExternal}>
                <h1 className={styles.previewTitle}>Preview:</h1>

                {hasImage && (<><img
                  className={styles.imgDestaquePreviewWebPush}
                  src={dataObj.imgDestaque}
                  alt="Imagem destaque"
                /></>)}
                <div className={styles.cardPreviewWebPush}>
                  <div className={styles.titlePreview}>
                    <div className={styles.titlePreviewlogo}>
                      <img
                        className={styles.imgPreviewWebPush}
                        src={dataObj.img ? dataObj.img : imgExemple}
                        alt="Logo"
                      />
                      <div className={styles.containerTextPreview}>
                        <h3 className={styles.titlePreview}>
                          {dataObj.title ? dataObj.title : "Titulo"}
                        </h3>
                        <p className={styles.descritionPreview}>
                          {dataObj.body ? `${dataObj.body.length < 120 ? dataObj.body.substring(0, 120) : dataObj.body.substring(0, 130).trimEnd() + '...'} ` : "Descrição"}
                        </p>
                        {/* <p className={styles.linkPreview}>
                          {data.url ? data.url : "https://www.santander.com.br"}
                        </p> */}
                      </div>
                      <span className={styles.containerClose}>
                        &#x2715;
                      </span>
                    </div>


                  </div>
                </div>
                <div className={styles.titlePreviewinfo}>
                  <p
                    className={styles.clientsRegistered}
                  >{(totalClient >= 0) && `${totalClient} clientes cadastrados`}</p>
                  {loading ? (
                    <Button disabled className={styles.btnSendWebPush}>
                      Agendando...
                    </Button>
                  ) : (
                    <DefaultButton
                      type={
                        Object.values(dataObj)
                          .filter(value => value === "").length > 0 ? "disabled" : "red"
                      }
                      size="LG"
                      onClick={
                        () => { handleOpenModalConfirm() }
                      }
                      children="Cadastrar Agendamento"
                    />
                  )
                  }
                </div>





              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
};

export default WebPush;
